import { MonthSelect } from "./FilterBar";
import { monthShift, useFilters } from "../store";

export function InpatientFeePeriodControl({ dateMin, dateMax }: { dateMin: string; dateMax: string }) {
  const f = useFilters();
  const min = dateMin.slice(0, 7);
  const max = dateMax.slice(0, 7);
  const baseMonth = f.periodTo.slice(0, 7);
  // 基準月を含む直近24か月を常に表示する。データ開始月より前には戻さない。
  const minBase = monthShift(`${min}-01`, 23).slice(0, 7);
  const setBaseMonth = (ym: string) => {
    f.setPeriodFrom(monthShift(`${ym}-01`, -23));
    f.setPeriodTo(`${ym}-01`);
  };
  const previous = monthShift(`${baseMonth}-01`, -1).slice(0, 7);
  const next = monthShift(`${baseMonth}-01`, 1).slice(0, 7);
  const navButton = "w-7 h-7 shrink-0 border border-slate-300 rounded bg-white text-slate-600 hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed";
  return <div className="space-y-1.5 text-xs">
    <div className="font-semibold text-slate-600">基準月</div>
    <div className="flex items-center gap-1">
      <button type="button" className={navButton} disabled={previous < minBase} onClick={() => setBaseMonth(previous)} title="前月">←</button>
      <MonthSelect value={baseMonth} min={minBase} max={max} onChange={setBaseMonth} className="min-w-0 flex-1 border border-slate-300 rounded px-2 py-1.5 bg-white" />
      <button type="button" className={navButton} disabled={next > max} onClick={() => setBaseMonth(next)} title="翌月">→</button>
    </div>
    <div className="text-[10px] leading-tight text-slate-400">基準月を含む過去24か月を表示</div>
  </div>;
}
